import App from './app-design-section';
import {
	polyfillForEachNodelist,
	polyfillEs6Promise,
	domParserPolyfill,
	polyfillRequestAnimationFrame,
	polyfillClassList,
	polyfillIncludes,
	polyfillRemove,
} from './components/polyfill/polyfill';

// *** NOT SUPPORTED BY IE8 ***
// element.addEventListener()
// event.preventDefault()
// function.bind()

// Needed for IE9 support.
polyfillForEachNodelist();

// Needed for IE9 support.
domParserPolyfill();

// Needed for IE9 support. (No scripts in the boilerplate uses RequestAnimationFrame, but it can be good to have if needed).
polyfillRequestAnimationFrame();

// Needed for IE11 suuport.
polyfillEs6Promise();

// Needed for IE8/IE9 support.
polyfillClassList();

polyfillIncludes();
polyfillRemove();
// Start the app.
new App();
